export default __webpack_public_path__ + "img/detectionsystem.c7895f0b.png";